import { useAppPathnameOutsideProvider } from "@/routing/navigation";
import React from "react";
import { Button } from "@mui/material";

import InfoCard from "@/ui/InfoCard";

export default function ErrorStatus({
  showReload = true,
  title = "Unexpected Error Occurred",
  description = "Please reload the page and try again.",
}: {
  showReload?: boolean;
  title?: string;
  description?: string;
}) {
  const location = useAppPathnameOutsideProvider();
  const isHome = location === "/" || location === "/dashboard";

  const handleHome = () => {
    window.location.href = "/";
  };
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <InfoCard
      title={title}
      description={description}
      imageAlt=""
      imageSrc="/error"
    >
      {!isHome && (
        <Button
          onClick={handleHome}
          variant="outlined"
          size="large"
          sx={{ my: 2 }}
        >
          Go Home
        </Button>
      )}
      {showReload && (
        <Button
          onClick={handleReload}
          variant="contained"
          size="large"
          sx={{ my: 2 }}
        >
          Reload Now
        </Button>
      )}
    </InfoCard>
  );
}
